import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import LeftSidebar from "./LeftSidebar";
import RightSidebar from "./RightSidebar";
import FloatingButton from "./FloatingButton";
import { useState } from "react";
import CreatePostModal from "./CreatePostModal";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const MobileRightDrawer = ({ isOpen, onClose }) => {

    return (
        <>
            {/* Overlay */}
            <div
                onClick={onClose}
                className={`fixed inset-0 z-40 bg-black/40 transition-opacity
        ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
            />

            {/* Drawer */}
            <div
                className={`fixed top-0 rtl:right-0 left-0 z-50 h-full w-[85%] max-w-sm
        bg-bg-light-primary dark:bg-bg-dark-primary
        transform transition-transform duration-300
        ${isOpen ? "rtl:translate-x-0 -translate-x-0" : "rtl:translate-x-full -translate-x-full"}`}
            >
                <LeftSidebar onClick={onClose} />
            </div>
        </>
    );
};


const MainLayout = () => {
    const [open, setOpen] = useState(false);
    const [mobileRightOpen, setMobileRightOpen] = useState(false);
    const location = useLocation();
    const { profile } = useSelector((state) => state.myProfile);
    const { i18n } = useTranslation();

    const locale = i18n.language === "ar" ? "ar" : "en";

    const role = profile?.role || "user";

    const isAdminRoute =
        location.pathname.startsWith("/settings") ||
        location.pathname.startsWith("/admin");

    // console.log(profile)
    return (
        <div className="flex w-full min-h-screen bg-bg-light-primary dark:bg-bg-dark-primary">

            {/* Left Sidebar */}
            <div className="hidden lg:block">
                <LeftSidebar />
            </div>

            {/* Center */}
            <main
                className={`flex-1 lg:ms-[16rem] ${isAdminRoute ? "lg:me-0" : "lg:me-[20rem]"}`}
            >
                <Navbar onToggleRight={() => setMobileRightOpen(true)} />
                <div className="px-4 py-6 ">
                    <Outlet />
                </div>
            </main>

            {/* Right Sidebar - Desktop */}
            {!isAdminRoute && (
                <div className="hidden lg:block">
                    <RightSidebar />
                </div>
            )}

            {/* Right Sidebar - Mobile Drawer */}
            {/* {!openMenu && ( */}
            <>
                <MobileRightDrawer
                    isOpen={mobileRightOpen}
                    onClose={() => setMobileRightOpen(false)}
                />
            </>
            {/* )} */}

            {/* Floating Button */}
            {!isAdminRoute && (role === "admin" || role === "owner") && (
                <>
                    <FloatingButton onClick={() => setOpen(true)} />
                    <CreatePostModal isOpen={open} onClose={() => setOpen(false)} companyName={locale === "ar" ? profile?.Companies?.[0]?.name_AR : profile?.Companies?.[0]?.name_EN} />
                </>
            )}
        </div>
    );
};

export default MainLayout;
